// 优选
// export const dns = 'https://api.youtp.cn'
// export const website = 1
// 智选
export const dns = 'https://api.zhixpoll.cn'
export const website = 2
//扬帆
// export const dns = 'https://api.yfpoll.com'
// export const website = 3
// 伙伴
// export const dns = 'https://api.gghe.com'
// export const website = 4
// 公正评选
// export const dns = 'https://api.zgpingxuan.com'
// export const website = 5
//新站点
// export const dns = 'https://api.fairvote.cn'
// export const website = 6